// Frontend constants mirroring backend translation system
export const TRANSLATABLE_FIELDS = {
  Circuit: [
    'name',
    'summary',
    'importantPoints',
    'priceIncludes',
    'priceExcludes',
    'modificationConditions',
    'cancellationConditions',
  ],
  CircuitDay: ['stepTitle', 'description'],
  CircuitAdditionalParagraph: ['title', 'content'],
  Benefit: ['name'],
  Activity: ['shortDescription', 'longDescription', 'city'],
  Pricing: ['name'],
  VehicleWithChauffeur: ['model', 'shortDescription', 'longDescription'],
  CarRental: [], // No translatable fields
  ComplementaryInsurance: ['name', 'shortDescription', 'longDescription'],
  Option: ['name', 'description'],
  Tax: ['name'],
  OneWayFee: ['name', 'departureCity', 'arrivalCity', 'description'],
  CarCategory: ['category', 'model', 'description', 'included', 'notIncluded'],
  Hotel: [
    'shortDescriptionTitle',
    'shortDescriptionBody',
    'longDescriptionTitle',
    'longDescriptionBody',
    'address',
    'city',
    'chain',
  ],
  Flight: ['shortDescription', 'longDescription'],
  HotelRoomCategory: [
    'name',
    'shortDescription',
    'longDescription',
    'category',
    'complementaryInformation',
  ],
  HotelRoomCategoryPricing: ['name'],
  Supplier: [],
} as const;

export const NESTED_TRANSLATABLE_ENTITIES = {
  Circuit: ['circuitDays', 'circuitAdditionalParagraphs'],
  CircuitDay: [],
  CircuitAdditionalParagraph: [],
  Benefit: ['Pricing'],
  Activity: ['benefit'],
  Pricing: [],
  VehicleWithChauffeur: ['benefit'],
  CarRental: [
    'benefit',
    'insurances',
    'options',
    'taxes',
    'oneWayFees',
    'carCategories',
  ],
  ComplementaryInsurance: [],
  Option: [],
  Tax: [],
  OneWayFee: [],
  CarCategory: ['insurances', 'options', 'taxes', 'oneWayFees', 'pricings'],
  Hotel: ['benefit', 'HotelRoomCategory'],
  Flight: ['benefit'],
  HotelRoomCategory: ['pricings'],
  HotelRoomCategoryPricing: [],
  Supplier: [],
} as const;

export type TranslatableEntityType = keyof typeof TRANSLATABLE_FIELDS;
export type TranslatableField<T extends TranslatableEntityType> =
  (typeof TRANSLATABLE_FIELDS)[T][number];
